import { render, staticRenderFns } from "./NitroBox.vue?vue&type=template&id=48af618a&scoped=true&"
import script from "./NitroBox.vue?vue&type=script&lang=ts&"
export * from "./NitroBox.vue?vue&type=script&lang=ts&"
import style0 from "./NitroBox.vue?vue&type=style&index=0&id=48af618a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af618a",
  null
  
)

export default component.exports